import { render, staticRenderFns } from "./ProgrammeAddedItem.vue?vue&type=template&id=8b265554&scoped=true"
import script from "./ProgrammeAddedItem.vue?vue&type=script&lang=js"
export * from "./ProgrammeAddedItem.vue?vue&type=script&lang=js"
import style0 from "./ProgrammeAddedItem.vue?vue&type=style&index=0&id=8b265554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b265554",
  null
  
)

export default component.exports